import { updateState } from '@fil-global/eiswagen';

import { DEVICE_RESIZE, PAGE_TRANSITION } from './constants';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case DEVICE_RESIZE:
      return updateState(state, { deviceType: action.data });
    case PAGE_TRANSITION:
      return updateState(state, { currentpage: action.page });
    default:
      return state;
  }
};
